<template>
  <div class="step-questions-last">
    <h2 class="text-[18px] text-primary mb-[27px]">
      {{ question.questionText }}
    </h2>
    <div class="question-description" v-if="question.questionDescription" v-html="question.questionDescription"></div>
    <ul v-if="hasInfoPoints">
      <li v-for="(point, idx) in question.infoPoints" :key="idx" v-html="point"></li>
    </ul>

    <button
      v-on:click="$emit('submit')"
      class="submit-and-continue"
      type="button"
      data-amplitude-id="proceed-to-checkout"
    >
      {{ isDe ? "Ich stimme zu" : "Agree and continue" }}
      <span v-if="useChevronIcon" class="chevron-right" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="16"
          height="16"
        >
          <path d="M9 6l6 6-6 6" />
        </svg>
      </span>
      <img
        v-else
        class="share-icons"
        :src="buttonArrowSrc"
        alt=""
        :width="buttonArrowWidth"
        :height="buttonArrowHeight"
        :style="{ width: buttonArrowWidth + 'px', height: buttonArrowHeight + 'px' }"
      />
    </button>

    <div class="comment" v-if="showComment">
      {{ comment }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import _ from "lodash";

import { YesNoQuestion } from "../../types";

export default Vue.extend({
  name: "AgreementQuestion",
  props: {
    theme: {
      type: String,
      required: true,
    },
    acceptTerms: {
      type: Boolean,
      required: true,
    },
    hostNameWithSchema: {
      type: String,
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    question: {
      type: Object as PropType<YesNoQuestion>,
      required: true,
    },
    showComment: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  created() {
    this.$emit("validation", this.question.id, true);
  },
  computed: {
    hasInfoPoints(): boolean {
      return !_.isEmpty(this.question.infoPoints);
    },
    useChevronIcon(): boolean {
      return this.theme === "medexpress" && process.env.REGION === "uk";
    },
    buttonArrowSrc(): string {
      // `black_right_arrow.svg` is the same as `@/ComponentLibrary/assets/arrow_right.svg` and is for levity theme
      return this.theme === "levity"
        ? "/resources/img/icons/black_right_arrow.svg"
        : "/resources/img/icons/white_right_arrow.svg";
    },
    // Remember to apply any changes here to StepConsultation.vue as well
    buttonArrowWidth(): number {
      return this.theme === "levity" ? 24 : 26;
    },
    // Remember to apply any changes here to StepConsultation.vue as well
    buttonArrowHeight(): number {
      return this.theme === "levity" ? 24 : 16;
    },
    isDe(): boolean {
      return process.env.REGION === "de";
    },
    doctorWord(): string {
      return process.env.REGION == "uk" ? "pharmacist" : "physician";
    },
    comment(): string {
      if (this.isDe) {
        return "Das Ärzteteam schaut sich Ihren Fragebogen an, nachdem Sie Ihr Medikament bestellt haben. Bei eventuellen Rückfragen wendet sich das Team an Sie.";
      }
      return `A ${this.doctorWord} will review your answers after you complete checkout`;
    },
  },
});
</script>

<style scoped>
.submit-and-continue .chevron-right {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  vertical-align: middle;
}
.submit-and-continue .chevron-right svg {
  display: block;
}
</style>
